import { css, cva } from '@/styled-system/css';

export const contentRecipe = cva({
  base: {
    width: '100%',
    // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 1220px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
    maxWidth: '1220px',
    paddingTop: '600',
    padding: { lg: '{spacing.600} {spacing.600} {spacing.1000} {spacing.600}' },
  },
  variants: {
    isLoading: {
      true: { opacity: '50%' },
      false: {},
    },
  },
});

export const spacerRecipe = cva({
  base: {},
  variants: {
    ignorePadding: {
      true: {
        marginLeft: '-600',
        marginRight: '-600',
      },
      false: {
        marginBottom: '400',
      },
    },
  },
});

export const actionsContainerStyles = css.raw({
  display: 'flex',
  justifyContent: { base: 'center', lg: 'flex-start' },
  alignItems: 'center',
  marginBottom: { base: '600', lg: '0' },
});
